/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Date
 * @desc Filter to toggle between deleted items
 */

import { FilterPostReportDateForm } from 'labstep-web/components/FilterPost/NewIndex/Date/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostNewIndexDateProps } from './types';

export const FilterPostNewIndexDate: React.FC<
  FilterPostNewIndexDateProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  replace,
  nullableField = true,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportDateForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        replace={replace}
        nullableField={nullableField}
      />
    )}
    {...rest}
  />
);
